// extracted by mini-css-extract-plugin
export var exploreLinks = "slide-module--exploreLinks--adb9f";
export var headline = "slide-module--headline--1b86a";
export var mixedMedia = "slide-module--mixedMedia--0c164";
export var slide = "slide-module--slide--b78de";
export var slideContent = "slide-module--slideContent--d8a54";
export var slideWrapper = "slide-module--slideWrapper--46f44";
export var subtext = "slide-module--subtext--fc336";